import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface ConversationCallTranscriptResponse {
  transcription_srt: string;
  // Number of the line, to tell the user apart in the SRT
  line_phone: string;
}

interface GetConversationCallTranscriptPayload {
  company_id: string;
  subscription_id: string;
  call_id: string;
}

export async function getConversationCallTranscript(
  payload: GetConversationCallTranscriptPayload,
  auth: Authentication,
): Promise<ConversationCallTranscriptResponse> {
  try {
    if (!payload.company_id || !payload.subscription_id || !payload.call_id) {
      throw new GetConversationCallTranscriptFailure('company_id, subscription_id et call_id sont requis');
    }

    const response = await HttpClient.post('/company/conversations/transcript', payload, auth.token);

    return response.data as ConversationCallTranscriptResponse;
  } catch (e) {
    console.error('getConversationCallTranscript error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetConversationCallTranscriptFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetConversationCallTranscriptFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetConversationCallTranscriptFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
